<div id="card"  [style.background]="setColor()">

  <p class="font-inter">+</p>


</div>
